module.exports = __webpack_public_path__ + "static/media/check.79ea7bbb.svg";